import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import { Link } from 'react-router';
import wwJpg from './images/ww.jpg';
import wJpg from './images/w.jpg';
import { lng } from './js/language.js';

function Prices() {
    const sectionPrices = useRef(null);
    const sectionCallToUs = useRef(null);
    const sectionQuestions = useRef(null);
    const location = useLocation();
    const {hash} = location;

    const [widthDisplay, setWidthDisplay] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidthDisplay(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = widthDisplay <= 768;

    const [isVisibleFadeIn, setIsVisibleFadeIn] = useState(isMobile ? true : false);
    const [isVisibleFadeInCallToUs, setIsVisibleFadeInCallToUs] = useState(isMobile ? true : false);
    const [isVisibleFadeInQuestions, setIsVisibleFadeInQuestions] = useState(isMobile ? true : false);
    const handleDistanceY = () => {
        setIsVisibleFadeIn(
            (sectionPrices.current.offsetTop - window.pageYOffset < 400 && sectionPrices.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionPrices.current.offsetTop < 1000 && window.pageYOffset - sectionPrices.current.offsetTop > -100) || isMobile
                ? true : false);
        setIsVisibleFadeInCallToUs(
            (sectionCallToUs.current.offsetTop - window.pageYOffset < 400 && sectionCallToUs.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionCallToUs.current.offsetTop < 600 && window.pageYOffset - sectionCallToUs.current.offsetTop > -100) || isMobile
                ? true : false);
        setIsVisibleFadeInQuestions(
            (sectionQuestions.current.offsetTop - window.pageYOffset < 400 && sectionQuestions.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionQuestions.current.offsetTop < 600 && window.pageYOffset - sectionQuestions.current.offsetTop > -100) || isMobile
                ? true : false);     
    };

    useEffect(() => {
        if (hash === '#prices') {      
            window.scrollTo({
                top: sectionPrices.current.offsetTop,
                behavior: "smooth",
            });
        }
        window.addEventListener('scroll', handleDistanceY);
        return () => {
            window.removeEventListener('scroll', handleDistanceY);
        };
    }, [hash, sectionPrices]);

    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);
    function handleCheckLang() {
        setCurrentLangObj(lng[localStorage.getItem('currentLang') || 'bg']);
    }
    useEffect(() => {
        window.addEventListener('click', handleCheckLang);
        return () => {
            window.removeEventListener('click', handleCheckLang);
        };
    }, []);

        return (
                <>
                    <section className="cta"  ref={sectionCallToUs}>
                        <div className="container">
                            <FadeIn
                                delay = {300}
                                transitionDuration = {300}
                                visible = {isVisibleFadeInCallToUs}
                            >
                                <div className="cta-content d-xl-flex align-items-center justify-content-around text-center text-xl-left">
                                    <br />
                                    <div className="content">
                                        <h2 className="no-waste-time">{currentLangObj.noWasteTime}</h2>
                                    </div>
                                    <div className="subscribe-btn">
                                        <Link to="/#contacts" className="btn btn-primary contact-us">
                                            {currentLangObj.touch}
                                        </Link>    
                                    </div>
                                </div>
                            </FadeIn>
                        </div>
                    </section>

                    <section className="pricing-table" id="prices" ref={sectionPrices}>
                        <div className="container">
                            <div className="title text-center">
                                <h1 className="title-blue offers-packages">{currentLangObj.offersPackages}</h1>
                            </div>                    
                            <FadeIn
                                delay = {300}
                                transitionDuration = {300}
                                visible = {isVisibleFadeIn}
                            >
                                <div className="row no-gutters">
                                    <div className="col">
                                        <div className="single-pricing text-center">
                                            <h2 className="offer-1-euro"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer1euro}} /></h2>
                                            <h2 className="offer-1"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer1}} /></h2>
                                            <p className="desc"></p>
                                            <div>
                                                <ul>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="static">{currentLangObj.static}</span>
                                                    </li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="to5">{currentLangObj.to5}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="one-language">{currentLangObj.oneLanguage}</span></li>
                                                    <li><i className="fa-solid fa-circle-xmark"></i><span className="seo">{currentLangObj.seo}</span>
                                                    </li>
                                                    <li><i className="fa-solid fa-circle-xmark"></i><span className="ssl">{currentLangObj.ssl}</span></li>
                                                    <li><i className="fa-solid fa-circle-xmark"></i><span className="full-managament">{currentLangObj.fullManagament}</span></li>
                                                </ul>
                                                <Link to="/#contacts" className="btn btn-primary make-an-inquiry">
                                                    {currentLangObj.makeAnInquiry}
                                                </Link> 
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="single-pricing text-center">
                                            <h2 className="offer-2-euro"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer2euro}} /></h2>
                                            <h2 className="offer-2"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer2}} /></h2>
                                            <p className="desc"></p>
                                            <div>
                                                <ul>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="no-static">{currentLangObj.noStatic}</span>
                                                    </li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="to15">{currentLangObj.to15}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="multi-language">{currentLangObj.multiLanguage}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="seo">{currentLangObj.seo}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="ssl">{currentLangObj.ssl}</span></li>
                                                    <li><i className="fa-solid fa-circle-xmark"></i><span className="managament">{currentLangObj.managament}</span></li>
                                                </ul>
                                            </div>
                                            <Link to="/#contacts" className="btn btn-primary make-an-inquiry">
                                                {currentLangObj.makeAnInquiry}
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="single-pricing text-center">
                                            <h2 className="offer-3-euro"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer3euro}} /></h2>
                                            <h2 className="offer-3"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer3}} /></h2>
                                            <p className="desc"></p>
                                            <div>
                                                <ul>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="no-static">{currentLangObj.noStatic}</span>
                                                    </li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="to15">{currentLangObj.to15}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="multi-language">{currentLangObj.multiLanguage}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="seo">{currentLangObj.seo}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="ssl">{currentLangObj.ssl}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="managament">{currentLangObj.managament}</span></li>
                                                </ul>
                                            </div>
                                            <Link to="/#contacts" className="btn btn-primary make-an-inquiry">
                                                {currentLangObj.makeAnInquiry}
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="single-pricing text-center">
                                            <h2 className="offer-4-euro"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer4euro}} /></h2>
                                            <h2 className="offer-4"><elem dangerouslySetInnerHTML={{ __html: currentLangObj.offer4}} /></h2>
                                            <p className="desc"></p>
                                            <div>
                                                <ul>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="no-static">{currentLangObj.noStatic}</span>
                                                    </li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="unlimited">{currentLangObj.unlimited}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="multi-language">{currentLangObj.multiLanguage}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="seo">{currentLangObj.seo}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="ssl">{currentLangObj.ssl}</span></li>
                                                    <li><i className="fa-solid fa-circle-plus"></i><span className="full-managament">{currentLangObj.fullManagament}</span></li>
                                                </ul>
                                            </div>
                                            <Link to="/#contacts" className="btn btn-primary make-an-inquiry">
                                                {currentLangObj.makeAnInquiry}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </FadeIn>
                        </div>
                    </section>

                    <section className="cta" ref={sectionQuestions}>
                        <div className="container">
                            <FadeIn
                                delay = {300}
                                transitionDuration = {300}
                                visible = {isVisibleFadeInQuestions}
                            >
                                <div className="cta-content d-xl-flex align-items-center justify-content-around text-center text-xl-left">
                                    <br />
                                    <div className="content">
                                        <h2 className="have-questions">{currentLangObj.haveQuestions}</h2>
                                    </div>
                                    <div className="subscribe-btn">
                                        <Link to="/#contacts" className="btn btn-primary contact-us">
                                            {currentLangObj.touch}
                                        </Link>
                                    </div>
                                </div>
                            </FadeIn>
                        </div>
                    </section>

                    <section className="featured">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="title">
                                        <h6 className="title-primary search-package">{currentLangObj.searchPackage}</h6>
                                        <h2 className="title-blue personal">{currentLangObj.personal}</h2>
                                    </div>
                                    <p>
                                        <span className="unique-projects">{currentLangObj.uniqueProjects}</span>
                                    </p>
                                    <h6 className="what-need centered">{currentLangObj.whatNeed}</h6>
                                    <div className="media-element  justify-content-between">
                                        <div className="media">
                                            <Link to="tel:+359887612233" className="call-us">
                                                <i className="fa fa-phone" aria-hidden="true"></i>{currentLangObj.callUs}
                                            </Link>
                                            <Link to="mailto:admin@vekota.bg" className="write-us">
                                                <i className="fa fa-envelope" aria-hidden="true"></i>{currentLangObj.writeUs}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="featured-img">
                                        <img className="featured-big width-80" src={wwJpg} alt="Featured 1" />
                                        <img className="featured-small width-40" src={wJpg} alt="Featured 2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
                );
    }

export default Prices;
